import { render, staticRenderFns } from "./info-schemes.vue?vue&type=template&id=045c255a&scoped=true&"
import script from "./info-schemes.vue?vue&type=script&lang=js&"
export * from "./info-schemes.vue?vue&type=script&lang=js&"
import style0 from "./info-schemes.vue?vue&type=style&index=0&id=045c255a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c255a",
  null
  
)

export default component.exports